/**
 * Toggle a `scrolled` class on <body> once the page has scrolled past 150px.
 */
export function initScroll() {
	const SCROLL_THRESHOLD = 150;

	const onScroll = () => {
		const scrollY = document.body.scrollTop || document.documentElement.scrollTop;
		document.body.classList.toggle( 'scrolled', scrollY > SCROLL_THRESHOLD );
	};

	window.addEventListener( 'scroll', onScroll, { passive: true } );
}
